// /home/ladmin/ESTATA/apps/0001-estata.com/frontend/src/components/CareersBanner.tsx

import { useNavigate } from "react-router-dom";
import { useBreakpoints } from "../hooks/Breakpoints.tsx";
import Container from "../hooks/Container.tsx";
import Button from "./ui/Button.tsx";
import { useLanguage } from "../lang/index.lang.tsx";
import { useState, useEffect } from "react";

interface HeroBannerProps {  
  subtitle: string;
  title: string;
  description: string;
  buttonText: string;
  buttonLink: string;
}

const HeroBanner = ({
  
  subtitle,
  title,
  description,
  buttonText,
  buttonLink,
}: HeroBannerProps) => {
  useBreakpoints();
  const navigate = useNavigate();

  const images = [
    "/images/EST-1284284200.jpg",    
    "/images/EST-3181557951.jpg",
    "/images/EST-6372937.jpg",
    "/images/EST-1338846217.jpg"   
  ];

  const [selectedImage, setSelectedImage] = useState("");

  useEffect(() => {
    const randomIndex = Math.floor(Math.random() * images.length);
    setSelectedImage(images[randomIndex]);
  }, []);

  return (
    <div className="text-white relative h-[calc(100vh-70px)] w-full mb-[100px] md:mb-[150px] lg:mb-[300px]"
      style={{
        backgroundImage: `url(${selectedImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >   
      <div className="absolute inset-0 flex items-center">
        <Container className="text-left md-text-center lg-text-center font-semibold w-[750px]">
          <div className="text-lg md:text-xl lg:text-2xl mb-5">
            {subtitle}
          </div>
          <div className="text-4xl md:text-4xl lg:text-6xl font-bold mb-5">
            {title}
          </div>
          <div className="text-lg md:text-xl lg:text-2xl mb-5">
            {description}
          </div>
          <Button to={buttonLink} variant="bordered" size="M">
            {buttonText}
          </Button>
          
        </Container>
      </div>
    </div>
  );
};

export default HeroBanner;